

export function csvStringToTable(csvString: string): string[][] {
    const rows = csvString.trim().split('\n');
    const table = rows.map(row => row.split(';').map(cell => cell.trim()));
    return table;
}